import React, { useEffect, useRef } from 'react'
// import * as echarts from 'echarts/core';
import st from './index.scss'
import cn from 'classnames'
/**
 * chenquan 2023-02-03
 * @param {object} options echarts 配置参数 必需
 * @param {} echarts echarts 必需
 * @returns
 */

function Echarts({ echarts, options, className, ...props }) {
    const chartRef = useRef()

    useEffect(() => {
        // 创建一个echarts实例，返回echarts实例
        const chart = echarts.init(chartRef.current)

        chart.setOption(options)

        return () => {
            // 销毁实例。实例销毁后无法再被使用
            chart.dispose()
        }
    }, [])

    return <div className={cn(st['echarts'],className)} {...props} ref={chartRef}></div>
}

export default function (arr, echarts) {
    echarts.use(arr)

    return ({ options, className, ...props }) => (
        <Echarts
            options={options}
            className={className}
            echarts={echarts}
            {...props}
        />
    )
}
